import { UpdateJiraIssuePlugin } from './UpdateJiraIssuePlugin';
import { CreateJiraIssuePlugin } from './CreateJiraIssuePlugin';
import { CreateSubTasksPlugin } from './CreateSubTasksPlugin';
import { PublishEventPlugin } from './PublishEventPlugin';
import { RemoveSubTasksPlugin } from './RemoveSubTasksPlugin';
import { TransitionEntityStatusFromJiraPlugin } from './TransitionEntityStatusFromJiraPlugin';
import { TransitionJiraIssuePlugin } from './TransitionJiraIssuePlugin';
import { UpdateRelatedEntityStatusPlugin } from './UpdateRelatedEntityStatusPlugin';
import { UpdateFieldFromJiraPlugin } from './UpdateFieldFromJiraPlugin';
import { SendEmailPlugin } from './SendEmailPlugin';

/**
 * Register service action plugins here
 */
const servicePlugins = [
  CreateSubTasksPlugin,
  RemoveSubTasksPlugin,
  PublishEventPlugin,
  UpdateRelatedEntityStatusPlugin,
  UpdateJiraIssuePlugin,
  CreateJiraIssuePlugin,
  TransitionJiraIssuePlugin,
  UpdateFieldFromJiraPlugin,
  TransitionEntityStatusFromJiraPlugin,
  SendEmailPlugin
];

export default servicePlugins;
